import { Head } from '@inertiajs/react';
import type { LandingsThreeD } from '@/types';
import { WireBus } from './components/wire-bus';

// `app/(public)/26-co/3d/page.tsx` — the same bus inside the square framing guide the
// 3D render is cropped to.
export default function ThreeD({ title, description }: LandingsThreeD) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <main className="relative min-h-dvh w-full overflow-hidden bg-black text-foreground md:h-dvh">
        <WireBus />
        <div
          className="pointer-events-none absolute inset-0 z-20 m-auto aspect-square border-2 border-red-500"
          style={{ width: 'min(90vw, 90vh)', height: 'min(90vw, 90vh)' }}
        />
      </main>
    </>
  );
}
